module.exports = __webpack_public_path__ + "static/media/icon-cc-pass-success.97600ee6.svg";